import { useState, useEffect, useRef } from "react";
import CheesecakeAdmin from "./CheesecakeAdmin";

// ─── CONFIG ───────────────────────────────────────────────────────────────────
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// ─── STYLES ───────────────────────────────────────────────────────────────────
const style = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Jost:wght@300;400;500&display=swap');
* { box-sizing: border-box; margin: 0; padding: 0; }
body { background: #FAF8F4; }

.ad-gate {
  min-height: 100vh;
  background: #FAF8F4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  font-family: 'Jost', sans-serif;
}
.ad-gate-logo { margin-bottom: 36px; }
.ad-gate-logo img { height: 64px; width: auto; }
.ad-gate-heading {
  font-family: 'Cormorant Garamond', serif;
  font-size: 28px;
  font-weight: 300;
  color: #1E1C18;
  margin-bottom: 32px;
  letter-spacing: 0.02em;
}
.ad-gate-form {
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ad-gate-input {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: #1E1C18;
  background: #fff;
  border: 1px solid #C8D5C0;
  padding: 12px 14px;
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
  letter-spacing: 0.05em;
}
.ad-gate-input:focus { border-color: #8C9E82; }
.ad-gate-btn {
  width: 100%;
  background: #8C9E82;
  color: #FAF8F4;
  border: none;
  padding: 13px;
  font-family: 'Jost', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s;
}
.ad-gate-btn:hover { background: #1E1C18; }
.ad-gate-error {
  font-size: 11px;
  font-weight: 300;
  color: #9E5A4A;
  text-align: center;
  letter-spacing: 0.04em;
  min-height: 16px;
}

.ad-app { font-family: 'Jost', sans-serif; background: #FAF8F4; color: #1E1C18; min-height: 100vh; }

.ad-header {
  background: #FAF8F4;
  border-bottom: 1px solid #C8D5C0;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
}
.ad-logo img { height: 52px; width: auto; }
.ad-header-right { display: flex; align-items: center; gap: 12px; }
.ad-badge {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #8C9E82;
  border: 1px solid #C8D5C0;
  padding: 4px 10px;
}

.ad-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: #C8D5C0;
  border-bottom: 1px solid #C8D5C0;
}
.ad-stat {
  background: #FAF8F4;
  padding: 20px 32px;
}
.ad-stat-label {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #8C9E82;
  margin-bottom: 6px;
}
.ad-stat-value {
  font-family: 'Cormorant Garamond', serif;
  font-size: 32px;
  font-weight: 300;
  color: #1E1C18;
  line-height: 1;
}

.ad-tabs {
  display: flex;
  border-bottom: 1px solid #C8D5C0;
  background: #FAF8F4;
  padding: 0 32px;
}
.ad-tab {
  font-family: 'Jost', sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #8C9E82;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 14px 20px;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  margin-bottom: -1px;
}
.ad-tab:hover { color: #1E1C18; }
.ad-tab.active { color: #1E1C18; border-bottom-color: #1E1C18; }

.ad-main {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 0;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  align-items: start;
}
@media (max-width: 900px) {
  .ad-main { grid-template-columns: 1fr; padding: 0 16px; }
  .ad-stats { grid-template-columns: 1fr 1fr; }
  .ad-tabs { padding: 0 16px; }
}

.ad-orders { padding: 32px 32px 32px 0; }
.ad-section-title {
  font-family: 'Jost', sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #8C9E82;
  margin-bottom: 20px;
}

.ad-order-card {
  background: #F2EDE4;
  border: 1px solid transparent;
  padding: 20px;
  margin-bottom: 12px;
  transition: border-color 0.2s;
}
.ad-order-card:hover { border-color: #C8D5C0; }

.ad-order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.ad-order-name {
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px;
  font-weight: 400;
  color: #1E1C18;
}
.ad-order-meta {
  font-size: 11px;
  font-weight: 300;
  color: #8C9E82;
  margin-top: 2px;
}
.ad-order-total {
  font-family: 'Cormorant Garamond', serif;
  font-size: 22px;
  font-weight: 300;
  color: #1E1C18;
}
.ad-order-items {
  border-top: 1px solid #C8D5C0;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ad-order-item {
  font-size: 12px;
  font-weight: 300;
  color: #1E1C18;
  display: flex;
  justify-content: space-between;
}
.ad-order-notes {
  margin-top: 10px;
  font-size: 11px;
  font-weight: 300;
  color: #8C9E82;
  font-style: italic;
  border-top: 1px solid #C8D5C0;
  padding-top: 8px;
}

.ad-empty {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 18px;
  color: #1E1C18;
  opacity: 0.4;
  padding: 40px 0;
}

.ad-sidebar {
  padding: 32px 0 32px 32px;
  border-left: 1px solid #C8D5C0;
  position: sticky;
  top: 85px;
  max-height: calc(100vh - 85px);
  overflow-y: auto;
}

.ad-prep-list { margin-bottom: 28px; }
.ad-prep-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #C8D5C0;
}
.ad-prep-item-name {
  font-size: 13px;
  font-weight: 300;
  color: #1E1C18;
  flex: 1;
}
.ad-prep-item-qty {
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px;
  font-weight: 400;
  color: #8C9E82;
  min-width: 32px;
  text-align: right;
}

.ad-summary-btn {
  width: 100%;
  background: #8C9E82;
  color: #FAF8F4;
  border: none;
  padding: 14px;
  font-family: 'Jost', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 16px;
}
.ad-summary-btn:hover { background: #1E1C18; }
.ad-summary-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.ad-summary-box {
  background: #F2EDE4;
  border: 1px solid #C8D5C0;
  padding: 20px;
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #1E1C18;
  line-height: 1.7;
  white-space: pre-wrap;
}

.ad-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 18px;
  color: #8C9E82;
  opacity: 0.6;
}

/* ── Products tab ─────────────────────────────────────────────────────────── */
.ad-products-panel {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
}
@media (max-width: 900px) {
  .ad-products-panel { padding: 24px 16px; }
}

.ad-product-category { margin-bottom: 36px; }
.ad-product-category-title {
  font-family: 'Jost', sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #8C9E82;
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #C8D5C0;
}

.ad-product-row {
  background: #F2EDE4;
  border: 1px solid transparent;
  padding: 16px 20px;
  margin-bottom: 8px;
  transition: border-color 0.2s;
}
.ad-product-row:hover { border-color: #C8D5C0; }

.ad-product-main {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.ad-product-info { flex: 1; min-width: 160px; }
.ad-product-name {
  font-family: 'Cormorant Garamond', serif;
  font-size: 18px;
  font-weight: 400;
  color: #1E1C18;
}
.ad-product-price {
  font-size: 11px;
  font-weight: 300;
  color: #8C9E82;
  margin-top: 2px;
}

.ad-product-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.ad-toggle-btn {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: 1px solid #C8D5C0;
  background: transparent;
  color: #8C9E82;
  padding: 6px 11px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.ad-toggle-btn:hover { border-color: #8C9E82; color: #1E1C18; }
.ad-toggle-btn.active { background: #1E1C18; color: #FAF8F4; border-color: #1E1C18; }
.ad-toggle-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.ad-edit-btn {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: 1px solid #C8D5C0;
  background: transparent;
  color: #8C9E82;
  padding: 6px 11px;
  cursor: pointer;
  transition: all 0.15s;
}
.ad-edit-btn:hover { border-color: #8C9E82; color: #1E1C18; }
.ad-edit-btn.open { background: #8C9E82; color: #FAF8F4; border-color: #8C9E82; }

.ad-product-edit {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #C8D5C0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ad-edit-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.ad-edit-field { display: flex; flex-direction: column; gap: 5px; }
.ad-edit-field-name { flex: 1; min-width: 180px; }
.ad-edit-field-price { width: 100px; }
.ad-edit-field-desc { width: 100%; }
.ad-edit-label {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #8C9E82;
}
.ad-edit-input {
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #1E1C18;
  background: #FAF8F4;
  border: 1px solid #C8D5C0;
  padding: 8px 10px;
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
}
.ad-edit-input:focus { border-color: #8C9E82; }
textarea.ad-edit-input { resize: vertical; min-height: 68px; line-height: 1.5; }
.ad-edit-save {
  align-self: flex-start;
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  background: #8C9E82;
  color: #FAF8F4;
  border: none;
  padding: 9px 20px;
  cursor: pointer;
  transition: background 0.2s;
}
.ad-edit-save:hover { background: #1E1C18; }
.ad-edit-save:disabled { opacity: 0.5; cursor: not-allowed; }

.ad-add-btn {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  background: #8C9E82;
  color: #FAF8F4;
  border: none;
  padding: 9px 20px;
  cursor: pointer;
  transition: background 0.2s;
}
.ad-add-btn:hover { background: #1E1C18; }
.ad-add-form {
  background: #F2EDE4;
  border: 1px solid #C8D5C0;
  padding: 24px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ad-add-form-title {
  font-family: 'Jost', sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #8C9E82;
}
.ad-add-form-actions { display: flex; gap: 10px; }
.ad-add-cancel {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  background: transparent;
  color: #8C9E82;
  border: 1px solid #C8D5C0;
  padding: 9px 20px;
  cursor: pointer;
  transition: all 0.2s;
}
.ad-add-cancel:hover { border-color: #8C9E82; color: #1E1C18; }
.ad-edit-select {
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #1E1C18;
  background: #FAF8F4;
  border: 1px solid #C8D5C0;
  padding: 8px 10px;
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
  cursor: pointer;
}
.ad-edit-select:focus { border-color: #8C9E82; }

.ad-order-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #8C9E82;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 3px;
}
`;

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const fmt = (p) => "$" + (p % 1 === 0 ? Number(p).toFixed(0) : Number(p).toFixed(2));

function getThisTuesday() {
  const now = new Date();
  const day = now.getDay(); // 0=Sun, 2=Tue
  const diff = day <= 2 ? 2 - day : 9 - day;
  const tuesday = new Date(now);
  tuesday.setDate(now.getDate() + diff);
  tuesday.setHours(0, 0, 0, 0);
  console.log("[getThisTuesday] now:", now.toString(), "| day:", day, "| diff:", diff, "| tuesday:", tuesday.toString());
  return tuesday;
}

// ─── ADMIN API HELPER ─────────────────────────────────────────────────────────
// The password is checked by the server on every call (x-admin-password header).
// Nothing secret is bundled into this file.
function getAdminPassword() {
  try { return sessionStorage.getItem(SESSION_KEY) || ""; } catch { return ""; }
}

async function adminFetch(path, { method = "POST", body } = {}) {
  const res = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json", "x-admin-password": getAdminPassword() },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (res.status === 401) {
    try { sessionStorage.removeItem(SESSION_KEY); } catch {}
    window.location.reload();
    throw new Error("Session expired. Please sign in again.");
  }
  return res;
}

async function fetchOrders() {
  if (!SUPABASE_URL || !SUPABASE_KEY) {
    return [
      {
        id: "1", created_at: new Date().toISOString(),
        customer_name: "Emily Johnson", customer_email: "emily@example.com",
        customer_phone: "(555) 234-5678", notes: "Please double bag the bread",
        items: [
          { name: "Fresh Milled Honey Wheat Bread — 13 inch", quantity: 2, price: 16 },
          { name: "Fresh Milled Brownie Mix", quantity: 1, price: 9 },
        ],
        total: 41,
      },
      {
        id: "2", created_at: new Date().toISOString(),
        customer_name: "Sarah Miller", customer_email: "sarah@example.com",
        customer_phone: "(555) 345-6789", notes: null,
        items: [
          { name: "Chai Concentrate — Regular 24 oz", quantity: 2, price: 16 },
          { name: "Elderberry Syrup — 16 oz", quantity: 1, price: 16 },
          { name: "Wellness Shots — 1 Week Supply", quantity: 1, price: 12 },
        ],
        total: 60,
      },
      {
        id: "3", created_at: new Date().toISOString(),
        customer_name: "Amanda Chen", customer_email: "amanda@example.com",
        customer_phone: "(555) 456-7890", notes: "Gluten free for daughter",
        items: [
          { name: "Fresh Milled Gluten Free Sandwich Bread", quantity: 1, price: 16 },
          { name: "Fresh Milled Pizza Dough", quantity: 2, price: 10 },
        ],
        total: 36,
      },
    ];
  }

  const tuesday = getThisTuesday();
  // Build UTC midnight-to-midnight range so timestamps like "2026-05-12T05:00:00.000Z"
  // are captured regardless of the local timezone offset.
  const tuesdayUTC = new Date(Date.UTC(tuesday.getFullYear(), tuesday.getMonth(), tuesday.getDate()));
  const nextDayUTC = new Date(Date.UTC(tuesday.getFullYear(), tuesday.getMonth(), tuesday.getDate() + 1));

  const res = await adminFetch("/api/store-settings", {
    body: { action: "list-orders", from: tuesdayUTC.toISOString(), to: nextDayUTC.toISOString() },
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`Failed to fetch orders (${res.status}): ${body}`);
  }
  const data = await res.json();
  return data.orders || [];
}

async function fetchProducts() {
  if (!SUPABASE_URL || !SUPABASE_KEY) {
    return [
      { id: 1, name: "Fresh Milled Honey Wheat Bread — 13 inch", price: 16, category: "Breads", description: "Our signature fresh-milled honey wheat loaf.", visible: true, sold_out: false, sort_order: 1 },
      { id: 2, name: "Fresh Milled Gluten Free Sandwich Bread", price: 16, category: "Breads", description: "Soft gluten-free sandwich loaf.", visible: true, sold_out: false, sort_order: 2 },
      { id: 3, name: "Fresh Milled Pizza Dough", price: 10, category: "Breads", description: "Two dough balls per order.", visible: true, sold_out: false, sort_order: 3 },
      { id: 4, name: "Fresh Milled Brownie Mix", price: 9, category: "Mixes", description: "Just add eggs, oil, and water.", visible: true, sold_out: false, sort_order: 4 },
      { id: 5, name: "Chai Concentrate — Regular 24 oz", price: 16, category: "Beverages", description: "Rich, spiced chai concentrate.", visible: true, sold_out: true, sort_order: 5 },
      { id: 6, name: "Elderberry Syrup — 16 oz", price: 16, category: "Beverages", description: "Immune-boosting elderberry syrup.", visible: false, sold_out: false, sort_order: 6 },
    ];
  }

  const res = await adminFetch("/api/store-settings", { body: { action: "list-products" } });
  if (!res.ok) throw new Error("Failed to fetch products");
  const data = await res.json();
  return data.products || [];
}

// Historical one-off orders where the old "I'd like this every week" checkbox
// was checked, across all time (not just this week) — the old `subscribe`
// column is still populated on those rows even though the checkbox itself has
// been replaced by the /subscription/signup button.
async function fetchInterestedOrders() {
  if (!SUPABASE_URL || !SUPABASE_KEY) {
    return [
      { id: "101", customer_name: "Jamie Lee", customer_email: "jamie@example.com", customer_phone: "(555) 111-2222", created_at: new Date().toISOString() },
    ];
  }

  const res = await adminFetch("/api/store-settings", { body: { action: "list-interested" } });
  if (!res.ok) throw new Error("Failed to fetch interested orders");
  const data = await res.json();
  return data.orders || [];
}

async function sendSubscriptionInvite(email, name, sendType) {
  const res = await adminFetch("/api/subscription-invite", { body: { email, name, sendType } });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to send invite");
  }
}

// Goes through the service-role backend, not the anon Supabase REST API —
// subscriptions/subscription_cycles hold card info and have no anon access.
// Returns both the subscriptions list and the recent manual-send log in one
// call since they're both admin-only views on the same tab.
async function fetchActiveSubscriptions() {
  const res = await adminFetch("/api/subscription-admin-list", { method: "GET" });
  if (!res.ok) throw new Error("Failed to fetch subscriptions");
  const data = await res.json();
  return { subscriptions: data.subscriptions || [], sends: data.sends || [] };
}

async function reactivateSubscription(subscriptionId) {
  const res = await adminFetch("/api/subscription-admin-list", { body: { action: "reactivate", subscriptionId } });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to reactivate subscription");
  }
}

async function sendSkipWeekNotice(bodyTemplate, subject) {
  const res = await adminFetch("/api/subscription-admin-list", { body: { action: "send-skip-week-notice", bodyTemplate, subject } });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to send notice");
  return data;
}

// Store-wide toggles read directly via the anon Supabase REST API (RLS
// allows anon SELECT on store_settings — it's non-sensitive, and App.jsx's
// public order form reads it the same way). Writes go through
// /api/store-settings.js using the service-role key.
async function fetchStoreSettings() {
  if (!SUPABASE_URL || !SUPABASE_KEY) {
    return { ordering_paused_from: null, ordering_paused_until: null, skip_pickup_week: null };
  }
  const url = `${SUPABASE_URL}/rest/v1/store_settings?id=eq.1&select=ordering_paused_from,ordering_paused_until,skip_pickup_week`;
  const res = await fetch(url, { headers: { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}` } });
  if (!res.ok) throw new Error("Failed to fetch store settings");
  const rows = await res.json();
  return rows[0] || { ordering_paused_from: null, ordering_paused_until: null, skip_pickup_week: null };
}

async function updateStoreSettings(updates) {
  const res = await adminFetch("/api/store-settings", { body: updates });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to update settings");
  }
}

// Upcoming Tuesdays for the skip-pickup-week date picker — deliberately
// simpler than App.jsx's getNextTuesdays (no cutoff/blocked-date filtering):
// Sara should be able to plan a skip for any upcoming Tuesday, not just ones
// still open for ordering.
function getUpcomingTuesdaysForAdmin(count = 6) {
  const tuesdays = [];
  const now = new Date();
  const day = now.getDay();
  const daysUntilTuesday = day <= 2 ? 2 - day : 9 - day;
  const candidate = new Date(now);
  candidate.setDate(now.getDate() + daysUntilTuesday);
  candidate.setHours(0, 0, 0, 0);
  for (let i = 0; i < count; i++) {
    tuesdays.push(new Date(candidate));
    candidate.setDate(candidate.getDate() + 7);
  }
  return tuesdays;
}

function toLocalISODate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

async function patchProduct(id, updates) {
  const res = await adminFetch("/api/store-settings", { body: { action: "patch-product", id, updates } });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(`${res.status}: ${data.error || "update failed"}`);
  }
}

async function postProduct(data) {
  const res = await adminFetch("/api/store-settings", { body: { action: "add-product", product: data } });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(`${res.status}: ${body.error || "add failed"}`);
  }
}

async function generateSummary(orders, prepList) {
  const itemSummary = prepList.map(i => `${i.name}: ${i.qty}`).join("\n");
  const orderDetails = orders.map(o =>
    `${o.customer_name} — ${o.items.map(i => `${i.name} x${i.quantity}`).join(", ")}${o.notes ? ` (Note: ${o.notes})` : ""}`
  ).join("\n");

  const res = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 1000,
      messages: [{
        role: "user",
        content: `You are helping Sara, a small-batch organic baker, prepare for her weekly bake.

Here are this week's orders:
${orderDetails}

Here is the prep list (product: quantity needed):
${itemSummary}

Write Sara a warm, practical weekly prep summary in her brand voice — honest, brief, never preachy. Include:
1. A quick overview of what this week looks like
2. The bake list in a logical order (breads first, then mixes, then other)
3. Any special notes from customers she should remember
4. A brief encouraging closing line

Keep it under 200 words. Write as if you're a helpful friend, not a corporate assistant.`,
      }],
    }),
  });

  const data = await res.json();
  return data.content?.[0]?.text || "Could not generate summary.";
}

// ─── PASSWORD GATE ────────────────────────────────────────────────────────────
const SESSION_KEY = "gg_admin_auth";

function PasswordGate({ onAuth }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const [checking, setChecking] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value || checking) return;
    setChecking(true);
    try {
      const res = await fetch("/api/store-settings", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-admin-password": value },
        body: JSON.stringify({ action: "verify" }),
      });
      if (res.ok) {
        sessionStorage.setItem(SESSION_KEY, value);
        onAuth();
        return;
      }
      setError(res.status === 500
        ? "Admin login isn't configured on the server yet."
        : "Incorrect password. Please try again.");
    } catch {
      setError("Couldn't reach the server. Please try again.");
    } finally {
      setChecking(false);
      setValue("");
    }
  };

  return (
    <div className="ad-gate">
      <style>{style}</style>
      <div className="ad-gate-logo">
        <img src="/logo.png" alt="Grind and Gather" />
      </div>
      <h1 className="ad-gate-heading">Admin Dashboard</h1>
      <form className="ad-gate-form" onSubmit={handleSubmit}>
        <input
          className="ad-gate-input"
          type="password"
          placeholder="Password"
          value={value}
          onChange={e => { setValue(e.target.value); setError(""); }}
          autoFocus
        />
        <button className="ad-gate-btn" type="submit" disabled={checking}>{checking ? "Checking…" : "Enter"}</button>
        <div className="ad-gate-error">{error}</div>
      </form>
    </div>
  );
}

// ─── PRODUCT ROW ──────────────────────────────────────────────────────────────
function ProductRow({ product, onRefresh }) {
  const [editing, setEditing] = useState(false);
  const [editForm, setEditForm] = useState({
    name: product.name,
    price: String(product.price),
    description: product.description || "",
    ingredients: product.ingredients || "",
  });
  const [saving, setSaving] = useState(false);
  const [toggling, setToggling] = useState(null); // "sold_out" | "visible" | null

  const handleToggle = async (field) => {
    setToggling(field);
    try {
      await patchProduct(product.id, { [field]: !product[field] });
      await onRefresh();
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setToggling(null);
    }
  };

  const handleEditOpen = () => {
    setEditForm({
      name: product.name,
      price: String(product.price),
      description: product.description || "",
      ingredients: product.ingredients || "",
    });
    setEditing(v => !v);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await patchProduct(product.id, {
        name: editForm.name.trim(),
        price: parseFloat(editForm.price) || 0,
        description: editForm.description.trim(),
        ingredients: editForm.ingredients.trim(),
      });
      await onRefresh();
      setEditing(false);
    } catch {
      alert("Failed to save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ad-product-row">
      <div className="ad-product-main">
        <div className="ad-product-info">
          <div className="ad-product-name">{product.name}</div>
          <div className="ad-product-price">{fmt(product.price)}</div>
        </div>
        <div className="ad-product-actions">
          <button
            className={`ad-toggle-btn${product.sold_out ? " active" : ""}`}
            onClick={() => handleToggle("sold_out")}
            disabled={toggling !== null}
          >
            {toggling === "sold_out" ? "…" : "Sold Out"}
          </button>
          <button
            className={`ad-toggle-btn${!product.visible ? " active" : ""}`}
            onClick={() => handleToggle("visible")}
            disabled={toggling !== null}
          >
            {toggling === "visible" ? "…" : "Hidden"}
          </button>
          <button
            className={`ad-edit-btn${editing ? " open" : ""}`}
            onClick={handleEditOpen}
          >
            {editing ? "Close" : "Edit"}
          </button>
        </div>
      </div>

      {editing && (
        <div className="ad-product-edit">
          <div className="ad-edit-row">
            <div className="ad-edit-field ad-edit-field-name">
              <label className="ad-edit-label">Name</label>
              <input
                className="ad-edit-input"
                value={editForm.name}
                onChange={e => setEditForm(f => ({ ...f, name: e.target.value }))}
              />
            </div>
            <div className="ad-edit-field ad-edit-field-price">
              <label className="ad-edit-label">Price ($)</label>
              <input
                className="ad-edit-input"
                type="number"
                min="0"
                step="0.01"
                value={editForm.price}
                onChange={e => setEditForm(f => ({ ...f, price: e.target.value }))}
              />
            </div>
          </div>
          <div className="ad-edit-field ad-edit-field-desc">
            <label className="ad-edit-label">Description</label>
            <textarea
              className="ad-edit-input"
              value={editForm.description}
              onChange={e => setEditForm(f => ({ ...f, description: e.target.value }))}
            />
          </div>
          <div className="ad-edit-field ad-edit-field-desc">
            <label className="ad-edit-label">Ingredients</label>
            <textarea
              className="ad-edit-input"
              value={editForm.ingredients}
              onChange={e => setEditForm(f => ({ ...f, ingredients: e.target.value }))}
            />
          </div>
          <button className="ad-edit-save" onClick={handleSave} disabled={saving}>
            {saving ? "Saving…" : "Save Changes"}
          </button>
        </div>
      )}
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function AdminDashboard() {
  const [authed, setAuthed] = useState(() => !!sessionStorage.getItem(SESSION_KEY));
  const [activeTab, setActiveTab] = useState("orders");

  // Orders state
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [error, setError] = useState(null);

  // Products state
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [productsError, setProductsError] = useState(null);
  const productsFetchedRef = useRef(false);

  // Subscriptions tab state (interested-order invites)
  const [interestedOrders, setInterestedOrders] = useState([]);
  const [interestedLoading, setInterestedLoading] = useState(false);
  const [interestedError, setInterestedError] = useState(null);
  const interestedFetchedRef = useRef(false);
  const [invitedIds, setInvitedIds] = useState(new Set());
  const [invitingId, setInvitingId] = useState(null);
  const [manualEmail, setManualEmail] = useState("");
  const [manualName, setManualName] = useState("");
  const [manualSending, setManualSending] = useState(false);
  const [manualSent, setManualSent] = useState(false);
  const [manualError, setManualError] = useState(null);

  // Subscriptions tab state (active subscriptions list)
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [adminSends, setAdminSends] = useState([]);
  const [activeSubsLoading, setActiveSubsLoading] = useState(false);
  const [activeSubsError, setActiveSubsError] = useState(null);
  const activeSubsFetchedRef = useRef(false);
  const [reactivatingId, setReactivatingId] = useState(null);

  // Store-wide toggles (pause ordering / skip a pickup week)
  const [storeSettings, setStoreSettings] = useState({ ordering_paused_from: null, ordering_paused_until: null, skip_pickup_week: null });
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [skipWeekDate, setSkipWeekDate] = useState("");
  const [pauseFromDate, setPauseFromDate] = useState("");
  const [pauseUntilDate, setPauseUntilDate] = useState("");
  const [noticeSubject, setNoticeSubject] = useState("A note about this week's pickup");
  const [noticeBody, setNoticeBody] = useState("");
  const [noticeSending, setNoticeSending] = useState(false);
  const [noticeResult, setNoticeResult] = useState(null);
  const [noticeError, setNoticeError] = useState(null);

  useEffect(() => {
    if (!authed) return;
    fetchOrders()
      .then(data => {
        setOrders(data);
        setCheckedOrders(new Set(data.map(o => o.id)));
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
    fetchStoreSettings().then(setStoreSettings).catch(() => {});
  }, [authed]);

  useEffect(() => {
    if (!authed) return;
    if (activeTab === "products" && !productsFetchedRef.current) {
      productsFetchedRef.current = true;
      loadProducts();
    }
    if (activeTab === "subscriptions" && !interestedFetchedRef.current) {
      interestedFetchedRef.current = true;
      loadInterestedOrders();
    }
    if (activeTab === "subscriptions" && !activeSubsFetchedRef.current) {
      activeSubsFetchedRef.current = true;
      loadActiveSubscriptions();
    }
  }, [activeTab, authed]);

  // Pre-fill the editable skip-week notice once a skip week is actually set,
  // and clear it back out when the skip is turned off.
  useEffect(() => {
    if (storeSettings.skip_pickup_week && !noticeBody) {
      const dateLabel = new Date(`${storeSettings.skip_pickup_week}T00:00:00Z`).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", timeZone: "UTC" });
      setNoticeBody(`Hey [Name], we're taking a break from pickups the week of ${dateLabel} — no charge, no action needed, we'll be back the following Tuesday!`);
    }
    if (!storeSettings.skip_pickup_week) {
      setNoticeBody("");
      setNoticeResult(null);
      setNoticeError(null);
    }
  }, [storeSettings.skip_pickup_week, noticeBody]);

  const loadActiveSubscriptions = () => {
    setActiveSubsLoading(true);
    setActiveSubsError(null);
    return fetchActiveSubscriptions()
      .then(({ subscriptions, sends }) => {
        setActiveSubscriptions(subscriptions);
        setAdminSends(sends);
      })
      .catch(e => setActiveSubsError(e.message))
      .finally(() => setActiveSubsLoading(false));
  };

  const handlePauseNow = async () => {
    setSettingsLoading(true);
    try {
      const from = toLocalISODate(new Date());
      await updateStoreSettings({ orderingPausedFrom: from, orderingPausedUntil: null });
      setStoreSettings(s => ({ ...s, ordering_paused_from: from, ordering_paused_until: null }));
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleSchedulePause = async () => {
    if (!pauseFromDate) return;
    setSettingsLoading(true);
    try {
      await updateStoreSettings({ orderingPausedFrom: pauseFromDate, orderingPausedUntil: pauseUntilDate || null });
      setStoreSettings(s => ({ ...s, ordering_paused_from: pauseFromDate, ordering_paused_until: pauseUntilDate || null }));
      setPauseFromDate("");
      setPauseUntilDate("");
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleResumeOrdering = async () => {
    setSettingsLoading(true);
    try {
      await updateStoreSettings({ orderingPausedFrom: null, orderingPausedUntil: null });
      setStoreSettings(s => ({ ...s, ordering_paused_from: null, ordering_paused_until: null }));
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleSetSkipWeek = async () => {
    if (!skipWeekDate) return;
    setSettingsLoading(true);
    try {
      await updateStoreSettings({ skipPickupWeek: skipWeekDate });
      setStoreSettings(s => ({ ...s, skip_pickup_week: skipWeekDate }));
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleResumeSkippedWeek = async () => {
    setSettingsLoading(true);
    try {
      await updateStoreSettings({ skipPickupWeek: null });
      setStoreSettings(s => ({ ...s, skip_pickup_week: null }));
    } catch {
      alert("Failed to update. Please try again.");
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleSendSkipWeekNotice = async () => {
    if (!noticeBody.trim()) return;
    if (!window.confirm("Send this notice to every active subscriber?")) return;
    setNoticeSending(true);
    setNoticeError(null);
    try {
      const result = await sendSkipWeekNotice(noticeBody, noticeSubject);
      setNoticeResult(result);
      loadActiveSubscriptions();
    } catch (err) {
      setNoticeError(err.message || "Failed to send notice.");
    } finally {
      setNoticeSending(false);
    }
  };

  const handleReactivate = async (sub) => {
    if (!window.confirm(`Reactivate ${sub.customerName}'s subscription?`)) return;
    setReactivatingId(sub.id);
    try {
      await reactivateSubscription(sub.id);
      await loadActiveSubscriptions();
    } catch {
      alert("Failed to reactivate. Please try again.");
    } finally {
      setReactivatingId(null);
    }
  };

  const loadProducts = () => {
    setProductsLoading(true);
    setProductsError(null);
    return fetchProducts()
      .then(setProducts)
      .catch(e => setProductsError(e.message))
      .finally(() => setProductsLoading(false));
  };

  const refreshProducts = () => fetchProducts().then(setProducts);

  const loadInterestedOrders = () => {
    setInterestedLoading(true);
    setInterestedError(null);
    return fetchInterestedOrders()
      .then(setInterestedOrders)
      .catch(e => setInterestedError(e.message))
      .finally(() => setInterestedLoading(false));
  };

  const handleInviteOrder = async (order) => {
    setInvitingId(order.id);
    try {
      await sendSubscriptionInvite(order.customer_email, order.customer_name, "interest_list");
      setInvitedIds(prev => new Set(prev).add(order.id));
    } catch {
      alert("Failed to send invite. Please try again.");
    } finally {
      setInvitingId(null);
    }
  };

  const handleManualInvite = async (e) => {
    e.preventDefault();
    if (!manualEmail.trim()) return;
    setManualSending(true);
    setManualError(null);
    try {
      await sendSubscriptionInvite(manualEmail.trim(), manualName.trim(), "manual");
      setManualSent(true);
    } catch (err) {
      setManualError(err.message || "Failed to send invite. Please try again.");
    } finally {
      setManualSending(false);
    }
  };

  const [showAddForm, setShowAddForm] = useState(false);
  const [addForm, setAddForm] = useState({ name: "", price: "", category: "", newCategory: "", description: "", ingredients: "" });
  const [addSaving, setAddSaving] = useState(false);

  const handleAddProduct = async () => {
    const category = addForm.category === "__new__" ? addForm.newCategory.trim() : addForm.category;
    if (!addForm.name.trim() || !addForm.price || !category) {
      alert("Please fill in name, price, and category.");
      return;
    }
    setAddSaving(true);
    try {
      await postProduct({
        name: addForm.name.trim(),
        price: parseFloat(addForm.price) || 0,
        category,
        description: addForm.description.trim(),
        ingredients: addForm.ingredients.trim(),
        visible: true,
        sold_out: false,
      });
      await loadProducts();
      setShowAddForm(false);
      setAddForm({ name: "", price: "", category: "", newCategory: "", description: "", ingredients: "" });
    } catch {
      alert("Failed to add product. Please try again.");
    } finally {
      setAddSaving(false);
    }
  };

  const totalRevenue = orders.reduce((sum, o) => sum + Number(o.total), 0);
  const totalItems = orders.reduce((sum, o) => sum + o.items.reduce((s, i) => s + i.quantity, 0), 0);

  // Build prep list
  const prepMap = {};
  orders.forEach(order => {
    order.items.forEach(item => {
      if (prepMap[item.name]) prepMap[item.name] += item.quantity;
      else prepMap[item.name] = item.quantity;
    });
  });
  const prepList = Object.entries(prepMap)
    .map(([name, qty]) => ({ name, qty }))
    .sort((a, b) => b.qty - a.qty);

  const tuesday = getThisTuesday();
  const dateLabel = tuesday.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });

  const adminTodayISO = toLocalISODate(new Date());
  const isPausedNow =
    !!storeSettings.ordering_paused_from &&
    adminTodayISO >= storeSettings.ordering_paused_from &&
    (!storeSettings.ordering_paused_until || adminTodayISO <= storeSettings.ordering_paused_until);
  const isPausedFuture = !!storeSettings.ordering_paused_from && adminTodayISO < storeSettings.ordering_paused_from;

  const [checkedOrders, setCheckedOrders] = useState(new Set());
  const [remindersSent, setRemindersSent] = useState(false);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const toggleOrder = (id) => {
    setCheckedOrders(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const handleSendReminders = async () => {
    const selectedOrders = orders.filter(o => checkedOrders.has(o.id));
    if (!window.confirm(`Send pickup reminders to ${selectedOrders.length} customer${selectedOrders.length === 1 ? "" : "s"}?`)) return;
    setRemindersLoading(true);
    try {
      const remRes = await adminFetch("/api/send-reminders", {
        body: { orders: selectedOrders, pickupDate: new Date(Date.now() + 86400000).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" }) },
      });
      if (!remRes.ok) throw new Error("reminders failed");
      setRemindersSent(true);
    } catch (e) {
      alert("Failed to send reminders. Please try again.");
    } finally {
      setRemindersLoading(false);
    }
  };

  const handleGenerateSummary = async () => {
    setSummaryLoading(true);
    try {
      const text = await generateSummary(orders, prepList);
      setSummary(text);
    } catch (e) {
      setSummary("Could not generate summary. Please try again.");
    } finally {
      setSummaryLoading(false);
    }
  };

  // Group products by category
  const productsByCategory = products.reduce((acc, p) => {
    const cat = p.category || "Uncategorized";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(p);
    return acc;
  }, {});
  const categories = Object.keys(productsByCategory).sort();

  if (!authed) return <PasswordGate onAuth={() => setAuthed(true)} />;

  return (
    <div className="ad-app">
      <style>{style}</style>

      <header className="ad-header">
        <div className="ad-logo">
          <img src="/logo.png" alt="Grind and Gather" />
        </div>
        <div className="ad-header-right">
          <span className="ad-badge">Admin · {dateLabel}</span>
        </div>
      </header>

      {/* Stats bar */}
      <div className="ad-stats">
        <div className="ad-stat">
          <div className="ad-stat-label">Orders This Week</div>
          <div className="ad-stat-value">{orders.length}</div>
        </div>
        <div className="ad-stat">
          <div className="ad-stat-label">Total Revenue</div>
          <div className="ad-stat-value">{fmt(totalRevenue)}</div>
        </div>
        <div className="ad-stat">
          <div className="ad-stat-label">Total Items</div>
          <div className="ad-stat-value">{totalItems}</div>
        </div>
      </div>

      {/* Tab nav */}
      <div className="ad-tabs">
        <button
          className={`ad-tab${activeTab === "orders" ? " active" : ""}`}
          onClick={() => setActiveTab("orders")}
        >
          Orders
        </button>
        <button
          className={`ad-tab${activeTab === "products" ? " active" : ""}`}
          onClick={() => setActiveTab("products")}
        >
          Products
        </button>
        <button
          className={`ad-tab${activeTab === "subscriptions" ? " active" : ""}`}
          onClick={() => setActiveTab("subscriptions")}
        >
          Subscriptions
        </button>
        <button
          className={`ad-tab${activeTab === "cheesecakes" ? " active" : ""}`}
          onClick={() => setActiveTab("cheesecakes")}
        >
          Cheesecakes
        </button>
      </div>

      {activeTab === "cheesecakes" && <CheesecakeAdmin />}

      {/* Orders tab */}
      {activeTab === "orders" && (
        <>
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 32px 0" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
              <div className="ad-order-card" style={{ flex: 1, minWidth: 260, marginBottom: 0 }}>
                <div className="ad-order-name" style={{ marginBottom: 8 }}>Ordering</div>
                <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, fontWeight: 300, color: "#1E1C18", opacity: 0.7, marginBottom: 10 }}>
                  {isPausedNow && (
                    storeSettings.ordering_paused_until
                      ? <>Paused — showing a capacity-reached message until <strong>{new Date(`${storeSettings.ordering_paused_until}T00:00:00Z`).toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" })}</strong>.</>
                      : "Paused indefinitely — showing a capacity-reached message until you resume."
                  )}
                  {isPausedFuture && (
                    <>Open for now — scheduled to pause starting <strong>{new Date(`${storeSettings.ordering_paused_from}T00:00:00Z`).toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" })}</strong>{storeSettings.ordering_paused_until ? <> through {new Date(`${storeSettings.ordering_paused_until}T00:00:00Z`).toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" })}</> : null}.</>
                  )}
                  {!storeSettings.ordering_paused_from && "Open — customers can place regular one-time orders normally."}
                </p>

                {storeSettings.ordering_paused_from ? (
                  <button className="ad-toggle-btn" disabled={settingsLoading} onClick={handleResumeOrdering}>
                    {settingsLoading ? "…" : "Resume Ordering"}
                  </button>
                ) : (
                  <>
                    <button className="ad-toggle-btn" disabled={settingsLoading} onClick={handlePauseNow}>
                      {settingsLoading ? "…" : "Pause Ordering Now"}
                    </button>
                    <div style={{ marginTop: 10, fontFamily: "'Jost', sans-serif", fontSize: 10, fontWeight: 500, letterSpacing: "0.12em", textTransform: "uppercase", color: "#8C9E82" }}>
                      Or schedule ahead
                    </div>
                    <div style={{ display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap", alignItems: "center" }}>
                      <input type="date" className="ad-edit-input" style={{ width: 140 }} value={pauseFromDate} onChange={e => setPauseFromDate(e.target.value)} />
                      <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 11, color: "#1E1C18", opacity: 0.6 }}>through</span>
                      <input type="date" className="ad-edit-input" style={{ width: 140 }} value={pauseUntilDate} onChange={e => setPauseUntilDate(e.target.value)} placeholder="Optional" />
                      <button className="ad-toggle-btn" disabled={settingsLoading || !pauseFromDate} onClick={handleSchedulePause}>
                        {settingsLoading ? "…" : "Schedule"}
                      </button>
                    </div>
                    <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 10, fontWeight: 300, color: "#1E1C18", opacity: 0.5, marginTop: 6, marginBottom: 0 }}>
                      Leave "through" blank to pause indefinitely until manually resumed.
                    </p>
                  </>
                )}
              </div>

              <div className="ad-order-card" style={{ flex: 1, minWidth: 260, marginBottom: 0 }}>
                <div className="ad-order-name" style={{ marginBottom: 8 }}>Pickup Week</div>
                {storeSettings.skip_pickup_week ? (
                  <>
                    <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, fontWeight: 300, color: "#1E1C18", opacity: 0.7, marginBottom: 10 }}>
                      Skipping pickup the week of{" "}
                      <strong>{new Date(`${storeSettings.skip_pickup_week}T00:00:00Z`).toLocaleDateString("en-US", { month: "long", day: "numeric", timeZone: "UTC" })}</strong>.
                      New subscription cycles won't be created for that week, and the order form won't offer it.
                    </p>
                    <button className="ad-toggle-btn" disabled={settingsLoading} onClick={handleResumeSkippedWeek}>
                      {settingsLoading ? "…" : "Resume This Pickup"}
                    </button>
                  </>
                ) : (
                  <>
                    <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 12, fontWeight: 300, color: "#1E1C18", opacity: 0.7, marginBottom: 10 }}>
                      No pickup at all that week — separate from pausing ordering above. Doesn't touch cycles already created for a week already in progress.
                    </p>
                    <div style={{ display: "flex", gap: 8 }}>
                      <select className="ad-edit-select" value={skipWeekDate} onChange={e => setSkipWeekDate(e.target.value)}>
                        <option value="">Choose a Tuesday…</option>
                        {getUpcomingTuesdaysForAdmin().map((d, i) => (
                          <option key={i} value={toLocalISODate(d)}>
                            {d.toLocaleDateString("en-US", { month: "long", day: "numeric" })}
                          </option>
                        ))}
                      </select>
                      <button className="ad-toggle-btn" disabled={settingsLoading || !skipWeekDate} onClick={handleSetSkipWeek}>
                        {settingsLoading ? "…" : "Skip This Pickup"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>

            {storeSettings.skip_pickup_week && (
              <div className="ad-add-form" style={{ marginTop: 12 }}>
                <div className="ad-add-form-title">Notify Subscribers of the Skipped Week</div>
                <div className="ad-edit-field">
                  <label className="ad-edit-label">Subject</label>
                  <input className="ad-edit-input" value={noticeSubject} onChange={e => setNoticeSubject(e.target.value)} />
                </div>
                <div className="ad-edit-field">
                  <label className="ad-edit-label">Message ("[Name]" is replaced per recipient)</label>
                  <textarea className="ad-edit-input" style={{ minHeight: 90 }} value={noticeBody} onChange={e => setNoticeBody(e.target.value)} />
                </div>
                <div className="ad-add-form-actions">
                  <button className="ad-edit-save" disabled={noticeSending || !noticeBody.trim()} onClick={handleSendSkipWeekNotice}>
                    {noticeSending ? "Sending…" : "Send to All Subscribers"}
                  </button>
                </div>
                {noticeError && <div style={{ fontSize: 12, color: "#9E5A4A" }}>{noticeError}</div>}
                {noticeResult && (
                  <div style={{ fontSize: 12, color: "#4a6b3f" }}>
                    Sent to {noticeResult.sent} of {noticeResult.total} active subscribers{noticeResult.failed > 0 ? ` (${noticeResult.failed} failed)` : ""}.
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="ad-main">
          <div className="ad-orders">
            <div className="ad-section-title">This Week's Orders — Pickup {dateLabel}</div>

            {loading && <div className="ad-loading">Loading orders…</div>}
            {error && <div className="ad-empty">Error loading orders: {error}</div>}
            {!loading && !error && orders.length === 0 && (
              <div className="ad-empty">No orders yet for this pickup date.</div>
            )}

            {orders.map(order => (
              <div key={order.id} className="ad-order-card">
                <div className="ad-order-header">
                  <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                    <input
                      type="checkbox"
                      className="ad-order-checkbox"
                      checked={checkedOrders.has(order.id)}
                      onChange={() => toggleOrder(order.id)}
                    />
                    <div>
                      <div className="ad-order-name">{order.customer_name}</div>
                      <div className="ad-order-meta">
                        {order.customer_email}
                        {order.customer_phone && ` · ${order.customer_phone}`}
                      </div>
                    </div>
                  </div>
                  <div className="ad-order-total">{fmt(order.total)}</div>
                </div>
                <div className="ad-order-items">
                  {order.items.map((item, i) => (
                    <div key={i} className="ad-order-item">
                      <span>{item.name}</span>
                      <span style={{ color: "#8C9E82", marginLeft: 12 }}>× {item.quantity}</span>
                    </div>
                  ))}
                </div>
                {order.notes && (
                  <div className="ad-order-notes">Note: {order.notes}</div>
                )}
              </div>
            ))}
          </div>

          {/* Sidebar — Prep list + summary */}
          <div className="ad-sidebar">
            <div className="ad-section-title">Prep List</div>

            {prepList.length === 0 ? (
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", fontSize: 15, color: "#1E1C18", opacity: 0.4, marginBottom: 24 }}>
                No items yet.
              </div>
            ) : (
              <div className="ad-prep-list">
                {prepList.map(item => (
                  <div key={item.name} className="ad-prep-item">
                    <span className="ad-prep-item-name">{item.name}</span>
                    <span className="ad-prep-item-qty">{item.qty}</span>
                  </div>
                ))}
              </div>
            )}

            <button
              className="ad-summary-btn"
              disabled={checkedOrders.size === 0 || remindersLoading || remindersSent}
              onClick={handleSendReminders}
              style={{ background: remindersSent ? "#C8D5C0" : "#1E1C18", marginBottom: 8 }}
            >
              {remindersLoading ? "Sending…" : remindersSent ? "✓ Reminders Sent" : `Send Pickup Reminders (${checkedOrders.size})`}
            </button>

            <button
              className="ad-summary-btn"
              disabled={orders.length === 0 || summaryLoading}
              onClick={handleGenerateSummary}
            >
              {summaryLoading ? "Generating…" : "Generate Prep Summary"}
            </button>

            {summary && (
              <div className="ad-summary-box">{summary}</div>
            )}

            <div style={{ marginTop: 16, fontSize: 10, fontWeight: 300, color: "#1E1C18", opacity: 0.4, lineHeight: 1.8 }}>
              Powered by Claude · Grind and Gather 2025
            </div>
          </div>
          </div>
        </>
      )}

      {/* Products tab */}
      {activeTab === "products" && (
        <div className="ad-products-panel">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <div className="ad-section-title" style={{ marginBottom: 0 }}>Product Management</div>
            {!showAddForm && (
              <button className="ad-add-btn" onClick={() => setShowAddForm(true)}>+ Add Product</button>
            )}
          </div>

          {showAddForm && (
            <div className="ad-add-form">
              <div className="ad-add-form-title">New Product</div>
              <div className="ad-edit-row">
                <div className="ad-edit-field ad-edit-field-name">
                  <label className="ad-edit-label">Name</label>
                  <input
                    className="ad-edit-input"
                    placeholder="Product name"
                    value={addForm.name}
                    onChange={e => setAddForm(f => ({ ...f, name: e.target.value }))}
                  />
                </div>
                <div className="ad-edit-field ad-edit-field-price">
                  <label className="ad-edit-label">Price ($)</label>
                  <input
                    className="ad-edit-input"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    value={addForm.price}
                    onChange={e => setAddForm(f => ({ ...f, price: e.target.value }))}
                  />
                </div>
              </div>
              <div className="ad-edit-field">
                <label className="ad-edit-label">Category</label>
                <select
                  className="ad-edit-select"
                  value={addForm.category}
                  onChange={e => setAddForm(f => ({ ...f, category: e.target.value, newCategory: "" }))}
                >
                  <option value="">Select a category…</option>
                  {categories.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                  <option value="__new__">New category…</option>
                </select>
              </div>
              {addForm.category === "__new__" && (
                <div className="ad-edit-field">
                  <label className="ad-edit-label">New Category Name</label>
                  <input
                    className="ad-edit-input"
                    placeholder="e.g. Jams & Spreads"
                    value={addForm.newCategory}
                    onChange={e => setAddForm(f => ({ ...f, newCategory: e.target.value }))}
                  />
                </div>
              )}
              <div className="ad-edit-field ad-edit-field-desc">
                <label className="ad-edit-label">Description</label>
                <textarea
                  className="ad-edit-input"
                  placeholder="Short product description"
                  value={addForm.description}
                  onChange={e => setAddForm(f => ({ ...f, description: e.target.value }))}
                />
              </div>
              <div className="ad-edit-field ad-edit-field-desc">
                <label className="ad-edit-label">Ingredients</label>
                <textarea
                  className="ad-edit-input"
                  placeholder="Ingredient list"
                  value={addForm.ingredients}
                  onChange={e => setAddForm(f => ({ ...f, ingredients: e.target.value }))}
                />
              </div>
              <div className="ad-add-form-actions">
                <button className="ad-edit-save" onClick={handleAddProduct} disabled={addSaving}>
                  {addSaving ? "Saving…" : "Save Product"}
                </button>
                <button
                  className="ad-add-cancel"
                  onClick={() => {
                    setShowAddForm(false);
                    setAddForm({ name: "", price: "", category: "", newCategory: "", description: "", ingredients: "" });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          {productsLoading && <div className="ad-loading">Loading products…</div>}
          {productsError && <div className="ad-empty">Error loading products: {productsError}</div>}
          {!productsLoading && !productsError && products.length === 0 && !showAddForm && (
            <div className="ad-empty">No products found.</div>
          )}

          {categories.map(cat => (
            <div key={cat} className="ad-product-category">
              <div className="ad-product-category-title">{cat}</div>
              {productsByCategory[cat].map(product => (
                <ProductRow key={product.id} product={product} onRefresh={refreshProducts} />
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Subscriptions tab */}
      {activeTab === "subscriptions" && (() => {
        const activeSubs = activeSubscriptions.filter(s => s.status === "active");
        const canceledSubs = activeSubscriptions.filter(s => s.status === "canceled");

        const renderSubCard = (sub) => (
          <div key={sub.id} className="ad-order-card">
            <div className="ad-order-header">
              <div>
                <div className="ad-order-name">{sub.customerName}</div>
                <div className="ad-order-meta">
                  {sub.email}
                  {sub.phone && ` · ${sub.phone}`}
                  {" · "}{sub.cardBrand || "Card"} ending in {sub.cardLast4 || "????"}
                  {sub.coverProcessingFee && " · Always covers fee"}
                </div>
              </div>
              {sub.status === "canceled" ? (
                <button
                  className="ad-toggle-btn"
                  disabled={reactivatingId === sub.id}
                  onClick={() => handleReactivate(sub)}
                >
                  {reactivatingId === sub.id ? "Reactivating…" : "Reactivate"}
                </button>
              ) : (
                <span className="ad-badge" style={{ color: "#8C9E82", borderColor: "#C8D5C0" }}>Active</span>
              )}
            </div>
            <div className="ad-order-items">
              {sub.baseItems.map((item, i) => (
                <div key={i} className="ad-order-item">
                  <span>{item.name}</span>
                  <span style={{ color: "#8C9E82", marginLeft: 12 }}>× {item.quantity}</span>
                </div>
              ))}
            </div>
            {sub.currentCycle && (
              <div className="ad-order-notes">
                This week ({sub.currentCycle.weekOfLabel}): {sub.currentCycle.status}
              </div>
            )}
          </div>
        );

        return (
        <div className="ad-products-panel">
          <div className="ad-section-title">Active Subscriptions ({activeSubs.length})</div>

          {activeSubsLoading && <div className="ad-loading">Loading…</div>}
          {activeSubsError && <div className="ad-empty">Error: {activeSubsError}</div>}
          {!activeSubsLoading && !activeSubsError && activeSubs.length === 0 && (
            <div className="ad-empty">No active subscriptions yet.</div>
          )}

          {activeSubs.map(renderSubCard)}

          {!activeSubsLoading && !activeSubsError && (
            <>
              <div className="ad-section-title" style={{ marginTop: 36 }}>Canceled Subscriptions ({canceledSubs.length})</div>
              {canceledSubs.length === 0 ? (
                <div className="ad-empty">No canceled subscriptions.</div>
              ) : (
                canceledSubs.map(renderSubCard)
              )}
            </>
          )}

          <div className="ad-section-title" style={{ marginTop: 36 }}>Invite Anyone to Subscribe</div>
          <form className="ad-add-form" onSubmit={handleManualInvite}>
            <div className="ad-edit-row">
              <div className="ad-edit-field ad-edit-field-name">
                <label className="ad-edit-label">Email Address</label>
                <input
                  className="ad-edit-input"
                  type="email"
                  placeholder="customer@example.com"
                  value={manualEmail}
                  onChange={e => { setManualEmail(e.target.value); setManualSent(false); setManualError(null); }}
                />
              </div>
              <div className="ad-edit-field ad-edit-field-name">
                <label className="ad-edit-label">Name (optional)</label>
                <input
                  className="ad-edit-input"
                  placeholder="Customer name"
                  value={manualName}
                  onChange={e => setManualName(e.target.value)}
                />
              </div>
            </div>
            <div className="ad-add-form-actions">
              <button className="ad-edit-save" type="submit" disabled={manualSending || !manualEmail.trim()}>
                {manualSending ? "Sending…" : manualSent ? "✓ Sent" : "Send Subscription Invite"}
              </button>
            </div>
            {manualError && (
              <div style={{ fontSize: 12, color: "#9E5A4A" }}>{manualError}</div>
            )}
          </form>

          <div className="ad-section-title" style={{ marginTop: 36 }}>Past Orders That Showed Interest</div>

          {interestedLoading && <div className="ad-loading">Loading…</div>}
          {interestedError && <div className="ad-empty">Error: {interestedError}</div>}
          {!interestedLoading && !interestedError && interestedOrders.length === 0 && (
            <div className="ad-empty">No past orders flagged as interested in a subscription.</div>
          )}

          {interestedOrders.map(order => (
            <div key={order.id} className="ad-order-card">
              <div className="ad-order-header">
                <div>
                  <div className="ad-order-name">{order.customer_name}</div>
                  <div className="ad-order-meta">
                    {order.customer_email}
                    {order.customer_phone && ` · ${order.customer_phone}`}
                    {" · "}{new Date(order.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                  </div>
                </div>
                <button
                  className="ad-toggle-btn"
                  disabled={invitingId === order.id || invitedIds.has(order.id)}
                  onClick={() => handleInviteOrder(order)}
                >
                  {invitingId === order.id ? "Sending…" : invitedIds.has(order.id) ? "✓ Invited" : "Send Invite"}
                </button>
              </div>
            </div>
          ))}

          <div className="ad-section-title" style={{ marginTop: 36 }}>Recent Sends</div>
          {adminSends.length === 0 ? (
            <div className="ad-empty">No manual sends logged yet.</div>
          ) : (
            adminSends.map(send => (
              <div key={send.id} className="ad-order-card" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontFamily: "'Jost', sans-serif", fontSize: 13, fontWeight: 300, color: "#1E1C18" }}>{send.recipient_email}</span>
                <span className="ad-order-meta">
                  {{ invite_interest_list: "Interest-list invite", invite_manual: "Manual invite", skip_week_notice: "Skip-week notice" }[send.email_type] || send.email_type}
                  {" · "}{new Date(send.sent_at).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}
                </span>
              </div>
            ))
          )}
        </div>
        );
      })()}
    </div>
  );
}